module.exports = __webpack_public_path__ + "static/button-mobile-elevation-dont-108795915543619cd355d0ea49b848e5.png";